import React, { MouseEventHandler, useRef, useState, useEffect } from "react";
import { DropdownItem } from "Components/ReactstrapSlim";
import { IHeaderMenuCountersViewModel, IMyVenueViewModel, UserVenuesClient } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { UserSelectorModel } from "Utils/selectors";
import { HeaderMemberDropDownMenu } from "./HeaderMemberDropDownMenu";

const venuesToDisplay = 6;
interface HeaderVenueAdminDropDownMenuProps {
   user: UserSelectorModel;
   headerMenuCounters: IHeaderMenuCountersViewModel;
   isEnterpriseManagment?: boolean;
}

let myVenuesStatic: IMyVenueViewModel[] = [];
let myVenuesPromise: Promise<void | IMyVenueViewModel[]> | null = null;

const viewAllVenuesHandler: MouseEventHandler<any> = e => {
   if (LiquidSpace?.View?.ManageVenueLayout) {
      LiquidSpace.View.ManageVenueLayout.showList();
      e.preventDefault();
   }
};

export const HeaderVenueAdminDropDownMenu: React.FC<HeaderVenueAdminDropDownMenuProps> = ({ user, headerMenuCounters, isEnterpriseManagment }) => {
   const userVenuesClient = useApiClient(UserVenuesClient);
   const [myVenues, setMyVenues] = useState(myVenuesStatic)
   const isMountedRef = useRef(true);

   useEffect(() => {
      if (!myVenuesPromise) {
         myVenuesPromise = userVenuesClient.getOwned(null, venuesToDisplay + 1)
            .then(r => myVenuesStatic = r);
      }
      myVenuesPromise.then(r => isMountedRef.current && setMyVenues(myVenuesStatic));

      return function cleanup() {
         isMountedRef.current = false;
      }
   }, []);

   return <div className="header-user-popup-va">
      <div className="header-user-popup-va-user">
         <HeaderMemberDropDownMenu user={user} headerMenuCounters={headerMenuCounters} isEnterpriseManagment={isEnterpriseManagment} />
      </div>
      <DropdownItem divider className="d-md-none" />
      <div className="header-user-popup-va-venues">
         {
            user.isVenueGroupAdmin
               ? <>
                  <DropdownItem header>Portfolio</DropdownItem>
                  <DropdownItem tag="a" href="/managevenuegroup">Dashboard</DropdownItem>
               </>
               : null
         }
         <DropdownItem header>
            My Venues
         </DropdownItem>
         {myVenues.slice(0, myVenues.length > venuesToDisplay ? venuesToDisplay - 1 : venuesToDisplay).map((venue, i) => <DropdownItem key={venue.venueId} tag="a" href={`/managevenue/${venue.venueId}`}>{venue.venueName}</DropdownItem>)}
         {
            myVenues.length > venuesToDisplay
               ? <DropdownItem tag="a" href="/managevenue?showVenueList=True" className="p2-strong ocean-blue lnk" onClick={viewAllVenuesHandler}>
                  View All Venues
               </DropdownItem>
               : null
         }
      </div>
   </div>
};